import React from "react";
import { authFileUrl } from "@/lib/api";
import { FileText, X } from "lucide-react";

// Renders a (possibly private) file reference as a thumbnail (images) or a link (docs).
export function FilePreview({ file, onRemove, size = 80 }) {
  if (!file) return null;
  const isImg = (file.content_type || "").startsWith("image") ||
    /\.(png|jpe?g|gif|webp)$/i.test(file.filename || file.url || "");
  const url = authFileUrl(file.url);
  return (
    <div className="relative group" style={{ width: size }}>
      {isImg ? (
        <a href={url} target="_blank" rel="noreferrer">
          <img
            src={url}
            alt={file.filename || "file"}
            className="rounded-md border border-[var(--border-2)] object-cover"
            style={{ width: size, height: size }}
          />
        </a>
      ) : (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="flex flex-col items-center justify-center rounded-md border border-[var(--border-2)] bg-[var(--panel-2)] text-[var(--text-2)] p-2"
          style={{ width: size, height: size }}
        >
          <FileText size={22} />
          <span className="text-[10px] mt-1 text-center line-clamp-2 break-all">
            {file.filename || "Document"}
          </span>
        </a>
      )}
      {onRemove && (
        <button
          type="button"
          onClick={() => onRemove(file)}
          className="absolute -top-2 -right-2 bg-red-600 text-white rounded-full p-0.5 opacity-90 hover:opacity-100"
          data-testid="file-remove-btn"
        >
          <X size={12} />
        </button>
      )}
    </div>
  );
}

export function FileGrid({ files = [], onRemove }) {
  if (!files || !files.length) return <p className="text-xs text-[var(--muted)]">None uploaded.</p>;
  return (
    <div className="flex flex-wrap gap-3">
      {files.map((f) => (
        <FilePreview key={f.id} file={f} onRemove={onRemove} />
      ))}
    </div>
  );
}
